export default "__VITE_ASSET__BA5yF4wy__"